export const siteConfig = {
  name: 'ZFAST Agritech India',
  legalName: 'ZFAST Agritech India',
  alternateNames: ['ZFAST', 'zfast', 'Zfast', 'ZFAST Agritech', 'Zfast Agritech India'],
  tagline: 'Nourishing India, Naturally',
  domain: 'https://zfastagritechindia.com',
  email: 'info@zfastagritechindia.com',
  phone: '+91 98120 13300',
  phoneHref: 'tel:+919812013300',
  whatsapp: 'https://wa.me/919812013300',
  address: '503, Shree GD Tower, Ajmer Rd, Neelkanth Colony, Vaishali Nagar, Jaipur, Rajasthan 302006',
  postalAddress: {
    streetAddress: '503, Shree GD Tower, Ajmer Rd, Neelkanth Colony, Vaishali Nagar',
    addressLocality: 'Jaipur',
    addressRegion: 'Rajasthan',
    postalCode: '302006',
    addressCountry: 'IN'
  },
  geo: {
    latitude: 26.9042,
    longitude: 75.7486
  },
  hasMap: 'https://maps.google.com/?q=Zfast+Agritech+India+Jaipur',
  openingHours: 'Mo-Sa 09:30-18:30',
  sameAs: [
    'https://www.facebook.com/zfastagritechindia',
    'https://www.instagram.com/zfastagritechindia',
    'https://www.linkedin.com/company/zfast-agritech-india',
    'https://twitter.com/zfastagritech'
  ],
  knowsAbout: [
    'Animal Nutrition',
    'Cattle Feed Manufacturing',
    'Dairy Cattle Nutrition',
    'Swine & Pig Feed Formulation',
    'Edible Oils Manufacturing & Wholesale',
    'Mustard Oil (Kachi Ghani)',
    'Soybean Refined Oil',
    'Sunflower Oil',
    'Aflatoxin-Controlled Feed Production',
    'Body Condition Scoring (BCS)',
    'Agricultural Supply Chain in India'
  ],
  currenciesAccepted: 'INR',
  paymentAccepted: 'Cash, Bank Transfer, UPI, Cheque',
  priceRange: '$$',
  addressPlaceholder: 'Contact our team for production, supply, dealership, and product availability details.',
  description:
    'ZFAST Agritech India supports Indian farmers, dealers, and distributors with cattle feed, pig feed, quality-focused animal nutrition, and edible oil supply.'
};

export const brandColors = {
  forest: '#1A5C2E',
  leaf: '#2D8A47',
  wheat: '#C8900A',
  cream: '#FAFAF7',
  tint: '#D8EFE0',
  ink: '#102118',
  charcoal: '#2C2C2A'
};
